import { createRouter, createWebHistory } from 'vue-router'
import { TokenService } from '@/services/token.service'
import GoogleRedirectLayout from '@/views/layout/GoogleRedirectLayout.vue'
import PagesView from '@/views/page/PagesView.vue'
import { ticketRoutes } from '@/router/ticket.router.ts'
import { jobRoutes } from '@/router/job.router.ts'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/p/home',
    },
    {
      path: '/p/',
      component: PagesView,
      children: [
        {
          path: '',
          redirect: '/p/home',
        },
        {
          path: 'home',
          name: 'home',
          component: () => import('@/views/page/home/HomeData.vue'),
          meta: {
            title: 'Home',
          },
        },
        ...ticketRoutes,
        ...jobRoutes,
      ],
    },
    {
      path: '/label/warranty',
      name: 'label-warranty',
      component: () => import('../views/layout/label/LabelWarrantyJob.vue'),
      meta: {
        title: 'Label Warranty Job',
      },
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: () => import('../views/layout/WelcomeLayout.vue'),
      meta: {
        title: 'Welcome to Panatech',
        public: true,
        onlyWhenLoggedOut: true,
      },
    },
    {
      path: '/google/callback',
      name: 'google-callback',
      component: GoogleRedirectLayout,
      meta: {
        title: '⌛ Log in with Google...',
        public: true,
        onlyWhenLoggedOut: true,
      },
    },
    {
      path: '/work-order/:id/print',
      name: 'work-order-print',
      component: () => import('../views/layout/cakrawala/CakrawalaWorkOrderPrint.vue'),
      meta: {
        title: 'Print Job',
        public: true,
        onlyWhenLoggedOut: false,
      },
    },
    {
      path: '/loan/:id/print',
      name: 'loan-print',
      component: () => import('../views/layout/cakrawala/CakrawalaLoanPrint.vue'),
      meta: {
        title: 'Print Loan',
        public: true,
        onlyWhenLoggedOut: false,
      },
    },
    {
      path: '/ticket/:id/sales',
      name: 'ticket-sales',
      component: () => import('../views/layout/cakrawala/CakrawalaPartSalesPrint.vue'),
      meta: {
        title: 'Print Part Sales',
        public: true,
        onlyWhenLoggedOut: false,
      },
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isPublic = to.matched.some((record) => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some((record) => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken()

  if (!isPublic && !loggedIn) {
    return next({
      path: '/welcome',
      query: { redirect: to.fullPath },
    })
  }

  if (loggedIn && onlyWhenLoggedOut) {
    return next('/p/home')
  }

  // title document
  document.title = to.meta.title || import.meta.env.VITE_APP_NAME

  next()
})

export default router
